import { JSX } from "react"
import { Navigate } from "react-router-dom"
import { PATH_MAP } from "../configuration/PathMap"
import { Permissions } from "../Enum/PermissionsType"
import { usePermission } from "../hooks/Permissions/usePermission"

const FulfillmentOnlyRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const canEditFulfillment = usePermission(Permissions.CanEditeFulfillment)

  return canEditFulfillment ? children : <Navigate to={PATH_MAP.HOME_PAGE} replace />
}

export default FulfillmentOnlyRoute
